import { useQueryClient } from 'react-query';
import { Modal, ModalContent } from 'src/shared/ui/components/Modal';

import { COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY } from '@legacy-hooks/api/company-user-certificates/useCompanyUserCertificates';

import { CertificateForm } from '@shared/certificates/components/CertificateForm';
import { createCertificateForUserAndCompany } from '@shared/certificates/endpoints/createCertificateForUserAndCompany';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { ModalTrigger } from '@shared/ui/components/Modal/ModalTrigger';

type CreateCertificateButtonProps = {
  userId: number;
  companyId: number;
};

export function CreateCertificateButton({ userId, companyId }: CreateCertificateButtonProps) {
  const queryClient = useQueryClient();

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button size="sm">
          <Icon icon="plus" /> Create
        </Button>
      </ModalTrigger>
      <ModalContent title="Upload Certificate" size="2xl" withoutAutoFocus>
        {({ close }) => (
          <CertificateForm
            action={(data) => createCertificateForUserAndCompany(userId, companyId, data)}
            onSave={() => {
              close();
              queryClient.invalidateQueries(COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY);
            }}
            onCancel={close}
          />
        )}
      </ModalContent>
    </Modal>
  );
}
